import { useUserStore } from '@bv/stores';

import AiIcon from '@/components/Icons/AiIcon.vue';
import CallCenterIcon from '@/components/Icons/CallCenter.vue';
import CampaignsIcon from '@/components/Icons/Campaigns.vue';

import type { ModuleLink } from '@bv/router';

export const sidebarModules: ModuleLink[] = [
  {
    icon: 'bvi-dashboard',
    route: '/dashboard',
    title: 'global.aside.dashboard',
    visible: true,
  },
  {
    icon: CallCenterIcon,
    route: '/call-center',
    title: 'global.aside.call_center',
    moduleName: 'call-center',
  },
  {
    icon: 'bvi-chart-line',
    route: '/reports',
    title: 'global.aside.reports',
    moduleName: 'reports',
  },
  // TODO: FF: Dialer
  // {
  //   icon: CampaignsIcon,
  //   route: '/dialer',
  //   title: 'global.aside.campaigns',
  //   // Owners always see the icon (to access upgrade state if disabled).
  //   // Non-owners only see it when the service is enabled AND they have module access.
  //   moduleName: 'campaigns',
  //   visible: () => {
  //     const store = useUserStore()
  //     return !!store.callCenterSettings?.dialer_service?.enabled || store.isOwner
  //   }
  // },
  {
    icon: CampaignsIcon,
    route: '/campaigns',
    title: 'global.aside.campaigns',
    // Owners always see the icon (to access upgrade state if disabled).
    // Non-owners only see it when the service is enabled AND they have module access.
    moduleName: 'campaigns',
    visible: () => {
      const store = useUserStore();
      return !!store.callCenterSettings?.dialer_service?.enabled || store.isOwner;
    },
  },
  {
    icon: AiIcon,
    route: '/ai',
    title: 'global.aside.ai',
    moduleName: 'ai-call-center',
    visible: () => {
      const store = useUserStore();
      return !!store.callCenterSettings?.ai_service.enabled;
    },
  },
  {
    icon: 'bvi-face-happy',
    route: '/call-evaluation',
    title: 'global.aside.call_evaluation',
    // Owners always see the icon (to access upgrade state if disabled).
    // Non-owners only see it when the service is enabled AND they have module access.
    moduleName: 'call-evaluation',
    visible: () => {
      const store = useUserStore();
      return !!store.callCenterSettings?.is_call_evaluation_enabled || store.isOwner;
    },
  },
  {
    icon: 'bvi-setting',
    route: '/settings',
    title: 'global.aside.settings',
    moduleName: 'settings',
  },
];
